import React, { useState, useEffect } from "react";
import "./styles.scss";
import Layout from "../../components/Layout/Layout";
import photo from "../../images/photo.png";
import { Link } from "react-router-dom";
import swal from "@sweetalert/with-react";

import { connect } from "react-redux";
import PropTypes from "prop-types";
import { fetchAuction, fetchPostBid } from "../../redux/actions/auctions";

import numberToComma from "../../utils/numberToComma";
import Auth from "../../config/auth";

const PlaceBid = (props) => {
  const {
    match: { params },
  } = props;
  const [auction, setAuction] = useState({});
  const [bids, setBids] = useState([]);
  const [amount, setAmount] = useState();
  const [check, setCheck] = useState(false);
  const user = Auth.getUser();

  const addBid = (e) => {
    e.preventDefault();
    setCheck(true);
    const data = { my_bid: parseInt(amount) };
    props.fetchPostBid(params.item, data);
  };

  useEffect(() => {
    props.fetchAuction(params.item);
  }, []);

  useEffect(() => {
    props.fetchAuction(params.item);
  }, [params.item]);

  useEffect(() => {
    if (props.auction.auction.data) {
      setAuction(props.auction.auction.data.auction);
      setBids(props.auction.auction.data.bids.bids);
      if (check) {
        props.auction.auction.message != null &&
          swal(props.auction.auction.message, "", "success");
        setAmount();
        props.fetchAuction(params.item);
        setCheck(false);
      }
    }
  }, [props.auction.auction]);

  useEffect(() => {
    if (props.auctionBid.auctionBid.data) {
      if (check) {
        props.auctionBid.auctionBid.message != null &&
          swal(props.auctionBid.auctionBid.message, "", "success");
        setAmount("");
        setCheck(false);
      }
    }
  }, [props.auctionBid.auctionBid]);

  useEffect(() => {
    if (props.auctionBid.errors.errors) {
      if (check) {
        props.auctionBid.errors.errors.message != null &&
          swal(props.auctionBid.errors.errors.message, "", "error");
        setAmount("");
        setCheck(false);
      }
    }
  }, [props.auctionBid.errors.errors]);

  return (
    <Layout>
      <section className="place-bid-section">
        <div className="bread-crumbs">
          <Link to="/">Home</Link>{" "}
          <i className="fa fa-caret-right pl-2 pr-2"></i>
          <Link to="/auction">Auction</Link>{" "}
          <i className="fa fa-caret-right pl-2 pr-2"></i>
          <Link to={`/place-bid/${auction.id}`}>
            Place bid -{auction.product ? auction.product.product_name : ""}
          </Link>
          <p className="title-page">Place bid</p>
        </div>

        <div className="row">
          <div className="col-md-3 mb-2">
            <div className="place-bid-item">
              <div className="place-bid-item-image-body">
                <img
                  src={auction.product ? auction.product.images[0] : ""}
                  width="100%"
                  alt="bids"
                />
              </div>
            </div>
          </div>
          <div className="col-md-6 mb-2">
            <div className="place-bid-item mb-3">
              <div className="place-bid-item-body p-4">
                <div className="d-flex justify-content-between">
                  <h2>{auction.product ? auction.product.product_name : ""}</h2>
                  <div className="product-container-heart">
                    {/* <span className="product-heart-container">
                      <i className="fa fa-heart-o" aria-hidden="true"></i>
                    </span> */}
                    <span className="product-heart-container">
                      <i
                        className="fa fa-share-square-o"
                        aria-hidden="true"
                      ></i>
                    </span>
                  </div>
                </div>
                <i className="fa fa-star bid" aria-hidden="true"></i>{" "}
                <span>3.5</span>
                <p className="bid">20 Bids</p>
                <h2>
                  ₦{" "}
                  {numberToComma(
                    auction.current_price ? auction.current_price : "no price"
                  )}
                </h2>
                <form onSubmit={addBid}>
                  <div className="form-group">
                    <input
                      type="number"
                      className="place-bid-input"
                      placeholder={`Enter Bid above ${numberToComma(
                        auction.current_price
                          ? auction.current_price
                          : "no price"
                      )}`}
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                      required
                    />
                  </div>

                  <button
                    type="submit"
                    className="sell btn-block btn btn-primary mt-4"
                  >
                    Place bid
                  </button>
                </form>
              </div>
            </div>
            <div className="place-bid-item">
              <div className="place-bid-item-body p-4">
                <h5 className="p-2">Leader board</h5>
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Bid no.</th>
                      <th scope="col">Amount</th>
                      <th scope="col">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(bids || []).map((item, i) => {
                      return (
                        <tr key={i}>
                          <th>
                            #{item.id} {user.id === item.user_id && "(YOU)"}
                          </th>
                          <td>{numberToComma(item.bid)}</td>
                          <td>{item.winner ? "Winning" : "Loosing"}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          {/* <div className="col-md-3 text-center mb-2">
           
            <div className="place-bid-item">
              <div className="place-bid-item-body">
                <div className="d-flex justify-content-center">
                  <img className="bid-image-container" src={photo} alt="" />
                </div>
                <h2>Shobbu Market Place</h2>
                <span>
                  <i className="fa fa-location-arrow" aria-hidden="true"></i>{" "}
                  Abule Egab Lagos, Nigeria
                </span>
                <div className="d-flex justify-content-center">
                  <div className="mt-3 pr-4 bid-ads">
                    <p>125</p>
                    <p>Ads</p>
                  </div>
                  <div className="ml-4 mt-3">
                    <p>125</p>
                    <p>Solds</p>
                  </div>
                </div>
                <div className="d-flex justify-content-center mt-3">
                 
                  <button className="btn btn-primary bid-btn mb-3"onClick={() =>
                  window.open(`http://shobbu.shobbu.com`, "_blank")
                }>view site</button>
                </div>
               
                <p>
                  ART DESIGN Nigeria Limited is an all round company created to
                  help sell in the shobbu market place.
                </p>
              </div>
            </div>
          </div> */}
        </div>
      </section>
    </Layout>
  );
};

PlaceBid.propTypes = {
  auction: PropTypes.object.isRequired,
  fetchAuction: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  auction: state.auction,
  auctionBid: state.auctionBid,
});

const pageActions = { fetchAuction, fetchPostBid };
export default connect(mapStateToProps, pageActions)(PlaceBid);
